export enum onlineCourseFormSurveys {
    SINGLE_CHOICE = "SINGLE_CHOICE",//ตัวเลือกเดียว
    MULTI_CHOICE = "MULTI_CHOICE",//หลายตัวเลือก
    DESCRIPTION = "DESCRIPTION"//ระบุคำตอบ
}

export enum RadioCourseOnlineValue {
    TRUE = "TRUE"
}

export enum STATUS_ONLINE_COURSE_FORM {
    ACTIVE = "active",
    DRAFT = "draft",
    INACTIVE = "inactive"
}

export enum STATUS_ONLINE_COURSE_FORM_TYPE {
    MANAGE_QUIZ = 'MANAGE_QUIZ', // จัดการแบบทดสอบ
    MANAGE_SURVEY = 'MANAGE_SURVEY' // จัดการแบบสำรวจ
}